<template>
    <b-container class="p-0">
        <b-row class="my-1" v-for="([prop , value], index) in Parameter.getProperties()" :key="prop + index">
                <!-- @Todo : Translate -->
                <b-col cols="3" class="m-auto">{{ prop }}</b-col>
                <b-col>
                    <b-form-input v-if="prop === 'Label'" v-model="Parameter[prop]" />
                    <b-form-input v-else v-model="Parameter[prop]" button-only right locale="fr" type="date" plain />
                </b-col>
            </b-row>
            <div class="w-100">
                <b-button class="float-right rounded-pill btn-outline-white bg-secondary btnIcon m-1 py-1 px-3" size="sm" variant="secondary" style="height: 2rem;"
                        @click="">
                    TEST
                </b-button>
                <b-button class="float-right rounded-pill btn-outline-secondary bg-white btnIcon m-1 py-1 px-3" size="sm" variant="outline-secondary" style="border-radius: 5px; height: 2rem;" 
                        @click="">
                    FIN
                </b-button>
            </div>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import DateField from '../Class/DateField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class DateFieldModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: DateField;

        public validateModal(){
            this.$emit('validate-modal', this.Parameter);
            console.log("Validate le truc : ")
        }

        public cancelModal(){
            this.$emit('cancel-modal');
            console.log("Cancel le truc : ")
        }
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>